const getters = {
  stepList: state => state.stepList,
  isMixed: state => state.isMixed,
  lowPlate: state => state.lowPlate,
  highPlate: state => state.highPlate,
  minPlate: state => state.minPlate,
  maxPlate: state => state.maxPlate,
  geometry: state => state.geometry
};

export default getters;
